const jobs = {
  update: {
    summary: {
      supplier: 'Fleet',
      notRouted: 'Not Distributed',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'Fleet',
      },
    },
  },
  table: {
    actions: {
      delete: 'Delete',
      export: 'Export',
      route: 'Distribute',
      cancel: 'Cancel',
      routeAndAssign: 'Route & Assign',
      group: 'Group',
      ungroup: 'Ungroup',
      blockWaitAndReturn: 'Disable Wait & Return',
      unblockWaitAndReturn: 'Enable Wait & Return',
      manualRoute: 'Manual Route',
      releaseRouting: 'Release Routing',
    },
    cells: {
      supplier: {
        none: 'No Fleet',
      },
      actions: {
        approve: 'Accept',
        remove: 'Decline',
      },
    },
    filters: {
      supplier: 'Fleets',
    },
    headers: {
      supplier: 'Fleets',
    },
    statuses: {
      new: 'Not Distributed',
      routed: 'Distributed',
      onHold: 'On hold',
      canceled: 'Canceled',
      routing: 'Routing',
      picked: 'Picked',
      dropped: 'Dropped',
      noshow: 'No Show',
    },
  },
};

export default jobs;
